module.exports = __webpack_public_path__ + "static/media/mountainx.08d1c593.png";